﻿import React from 'react';
import { DmaAppConstants } from '../store/application-defaults';

export default function DmaFooter() {
    return (
        <div className="pw-form-bottom">
            <span className="pw-form-bottom-text">{DmaAppConstants.name}</span>
        </div>
    )

}
